/* eslint-disable react-hooks/rules-of-hooks */
import { useTranslation } from 'react-i18next';

export function useLoadAllTranslations(): boolean {
    let allReady = true;
    // It is ok to call useTranslation hook in a loop in this case, because __I18N_NAMESPACES__ is a constant defined
    // at compile time, and it never changes. See file <project-dir>/webpack.config.js where this constant is calculated.
    // In all other cases do not call React hooks in a loop. See this article for more information:
    // https://legacy.reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
    for (const namespace of __I18N_NAMESPACES__) {
        // A fake cast from string to 'webeoc-downloads' is necessary, without it TypeScript will complain.
        // All types for namespaces are declared in file <project-dir>/src/ui/@types/i18next.d.ts in this file
        // only 'webeoc-downloads' is declared there because at compile time we need to know only about it.
        const namespaceReady = useTranslation(namespace as 'webeoc-downloads').ready;
        allReady &&= namespaceReady;
    }
    return allReady;
}
